<template>
  <div class="gradient z-header">
    <div class="header-left" :class="{'logo-small': toggleFlag}">
      <div class="logo-box" @click="toHome">
        <img class="logo-img1" v-if="!toggleFlag" src="../../../assets/z-header/logo.png"/>
        <img class="logo-img2" v-if="toggleFlag" src="../../../assets/z-header/group.png" @click="upMenu"/>
        <div class="title">档案管理</div>
      </div>

    </div>

    <div class="z-header-toolbar">
      <ul class="ul1">
        <li  class="account-set-switch">
          <span class="organization-name">{{organizationName}}</span>
          <el-select class="test-select" :value="currOrgId" filterable
                     popper-class="test-select"
                     @change="handleChangeOrgId"
                     placeholder="请选择">
            <el-option v-for="item in orgList"
                       :key="item.id"
                       :value="item.id"
                       :label="item.name"
            >
            </el-option>
          </el-select>
        </li>
      </ul>
      <ul class="ul2">
        <!--个人信息-->
        <li class="zheader-personal-center ">
          <div class="z-header-user">{{userName}}</div>
          <div class="personal-center">
            <div class="personImg">
              <img src="../../../assets/z-header/head-portrait-small.png"  v-if="headerImgId===''||headerImgId===null">
              <img :src="setimgSrc" v-else >
            </div>
            <div class="popover-box">
              <div class="person-box" ></div>
              <ul class="handle-popover">
<!--                <li class="popover-li"  @click="personal"> 个人中心</li>-->
                <li class="popover-li"  @click="handleQuit">退出</li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import {mapState, mapActions, mapMutations, mapGetters} from "vuex";
  import {onClosePage} from "../../../libs/LifecycleManager";
  import AppPersistence from "../../../persistence/AppPersistence";
  import UserPersistence from "../../../persistence/UserPersistence";
  import {ROUTER_NAME_HOME} from "../../../router/router";
  import {EXIT_URL} from "../../../config/app";

export default {
    name: "z-header",
  data() {
    return {
      userId:'',
      value: '',
      tokenData: UserPersistence.getToken()
    }
  },
  watch:{
    logoutVisible() {
      if(this.logoutVisible){
        let EXITURL = EXIT_URL();
        this.setLogout(false);
        AppPersistence.clear();
        UserPersistence.clear();
        this.setUserBaseInfo(null);
        if (process.env.NODE_ENV !== 'development') {//开发环境
          window.location.href = EXITURL;
        } else {//localhost
          this.$router.push({name: 'login'});
        }
      }
    },
    changeStatus(newValue){
      if(newValue){
        this.getMenus({flag: false});
        this.closeAllPage();
      }
    },
  },
  computed: {
    ...mapState("route", {
      name: state => state.name
    }),
    ...mapState("app", {
      pageTagsList: state => state.pageOpenedList
    }),
    ...mapState("user", {
      organizationName: state => {
        if (state.userBaseInfo) {
          return state.userBaseInfo.user.organizationName
        }if (UserPersistence.getBaseInfo().user) {
          return UserPersistence.getBaseInfo().user.organizationName;
        }
        return '';
      },
      userName: state => {
        if (state.userBaseInfo) {
          return state.userBaseInfo.user.name
        }if (UserPersistence.getBaseInfo().user) {
          return UserPersistence.getBaseInfo().user.name;
        }
        return '';
      },
      orgList: state => state.userBaseInfo.orgList,
      currOrgId: state => state.userBaseInfo.orgId,
    }),
    ...mapState('zHeader',[
      'headerImgId',
      'hostnameAddress', //主机名字
      'openHomePage',
      'logoutVisible',
      'changeStatus',
      'toggleFlag'
    ]),
    ...mapState('message-center', [
      'countNoRead'
    ]),
    setimgSrc() {
      return `${this.hostnameAddress}/ctx-user/v1/files/getImage/long100/${this.headerImgId}?token=${this.tokenData}`
    },
    companyName(){ // usertype 1 机构用户 2 公司用户  isManager 是否管理员
      if(UserPersistence.getBaseInfo().user.usertype === 1){
        return UserPersistence.getBaseInfo().organizationName
      }
      if(UserPersistence.getBaseInfo().user.usertype === 2){
        return UserPersistence.getBaseInfo().organizationName
      }
    },
  },
  methods: {
    ...mapActions("user", [
      "getMenus",
    ]),
    ...mapMutations("user", [
      "loadBaseInfo",
      "setUserBaseInfo",
      "setOrgId",
    ]),
    ...mapActions("zHeader",[
      'initView',
      'logout',
      'changeUserOrg'
    ]),
    ...mapMutations("app",[
      "removeLastTags",
      'removeAllTag'
    ]),
    ...mapMutations("personal",[
      'setSaveState'
    ]),
    ...mapMutations("zHeader", [
      'setCurrOrgId',
      'setHostnameAddress',
      'setCreateAccount',
      'setLogout',
      'setCurrOrgId',
      'setChangeStatus',
      'setToggleFlag'
    ]),
    toHome(){
      this.$router.push({ name: "home" });
    },
    handleChangeOrgId(id){
      this.setOrgId(id)
      if(this.$route.name !== 'home') this.$router.push({ name: "home" });
      // this.changeUserOrg(id);
    },
    closeAllPage() {
      let pageOpenedList = this.pageTagsList;
      let path, removeNamesCount = pageOpenedList.length - 1;
      for (let i = pageOpenedList.length - 1; i >= 0; i--) {
        path = pageOpenedList[i].fullPath;
        onClosePage(path, true);
      }
      let location = {path: "/home"};
      this.$router.replace(location, () => {
        this.removeLastTags(removeNamesCount);
      });
    },
    handleQuit() {
      this.logout();
    },
    personal() {
      this.$router.push({name: 'personal-center'})
    },
    //展开侧边栏
    upMenu() {
      this.setToggleFlag(false);
    }
  },
  mounted() {
    //获取主机地址
    if(process.env.NODE_ENV !== 'development') {
      this.setHostnameAddress(process.env.BASE_API)
    }
    this.initView();
    this.setCurrOrgId(UserPersistence.getBaseInfo().id);
  }
};
</script>
<style lang="scss" scoped>
@import "z-header";
//头部渐变背景色
</style>



// WEBPACK FOOTER //
// src/views/components/Header/z-header.vue